import React, { useEffect, useState } from "react";
import { NavLink, useParams, useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import { useJwt } from "react-jwt";
import {
  EditNotificationAPI,
  getByIdNotification,
  GetProductStatus,
} from "../apiconfig/authService";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";
import { RiLoaderFill } from "react-icons/ri";
import { toast } from "react-toastify";

function Editnotification(props) {
  const navigate = useNavigate();
  const { isExpired } = useJwt(localStorage.getItem("accessToken"));
  const { id } = useParams();

  const setMediaTableViewMessage = props.setMessage;

  const [editedMediaData, setEditedMediaData] = useState({
    title: "",
    shortdescription: "",
    selecteddate: dayjs(),
    statusid: "",
  });
  const [statusData, setStatusData] = useState([]);
  const [value, setValue] = useState(dayjs());
  const [dbDate, setDbDate] = useState(dayjs()); // store original DB date
  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);  

  useEffect(() => {
    if (isExpired) {
      navigate("/");
    }
  }, [isExpired, navigate]);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const response = await getByIdNotification(
          id,
          localStorage.getItem("accessToken")
        );
        const data = response.data.response;
        setEditedMediaData(data);

        if (data.selecteddate) {
          const dbDateValue = dayjs(data.selecteddate);
          setValue(dbDateValue);
          setDbDate(dbDateValue); // save original DB value for comparison
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  useEffect(() => {
      (async () => {
          setLoading(true);
      try {
        const statusResponse = await GetProductStatus(
          localStorage.getItem("accessToken")
        );
          setLoading(true);
        setStatusData(statusResponse.data);
      } catch (error) {
        console.error(error);
      } finally {
          setLoading(false);
      }
    })();
  }, []);

  const handleTitleChange = (e) => {
    setEditedMediaData({ ...editedMediaData, title: e.target.value });
  };

  const handleDescriptionChange = (e) => {
    setEditedMediaData({
      ...editedMediaData,
      shortdescription: e.target.value,
    });
  };

  const handleStatusChange = (e) => {
    setEditedMediaData({ ...editedMediaData, statusid: e.target.value });
  };

  const handleChange = (newValue) => {
    setValue(newValue);
  };

    const handleDiscardClick = () => {
        navigate("/")
    };

  const handleSubmitClick = async (e) => {
    e.preventDefault();

    // ✅ Title & Description validation
    if (!editedMediaData.title.trim()) {
      toast.error("Title is required!");
      return;
    }
    if (!editedMediaData.shortdescription.trim()) {
      toast.error("Description is required!");
      return;
    }

    // ✅ Date validation only if admin changed it
    const isDateChanged = !dayjs(value).isSame(dbDate);

    if (isDateChanged) {
      const nowPlus5 = dayjs().add(5, "minute");

      if (!dayjs(value).isValid()) {
        toast.error("Please select a valid date & time!");
        return;
      }

      if (dayjs(value).isBefore(nowPlus5)) {
        toast.error("Scheduled time must be at least 5 minutes from now!");
        return;
      }

      // Update selected date if valid
      editedMediaData.selecteddate = value.toISOString();
    } else {
      // Keep old date if not changed
      editedMediaData.selecteddate = dbDate.toISOString();
    }

    const data = {
      id,
      title: editedMediaData.title,
      shortdescription: editedMediaData.shortdescription,
      selecteddate: editedMediaData.selecteddate,
    };

    try {
        setEditLoading(true);
      const response = await EditNotificationAPI(
        data,
        localStorage.getItem("accessToken")
      );

      if (response.status === 200) {
        setEditLoading(false);
        toast.success("Notification Updated Successfully");
        setMediaTableViewMessage(response.data.message);
        navigate("/notification");
      }
    } catch (err) {
      const errorMsg =
        err?.response?.data?.error ||
        "An error occurred. Please try again later.";
      toast.error(errorMsg);
      window.scrollTo(0, 0);
    } finally {
        setEditLoading(false);
    }
  };

  return (
    <div className="dashboard-content">
      <Sidebar />
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Edit Notification</h1>
          <NavLink to="/media" className="btn btn-primary">
            View All
          </NavLink>
        </div>

        {loading ? (
          <div className="d-flex align-items-center justify-content-center">
            <RiLoaderFill
              size={40}
              className="text-success spin-animation text-center"
            />
          </div>
        ) : (
          <div
            role="tabpanel"
            className="personal-info tab-pane active storetab"
            id="pi"
          >
            <div className="row">
              <div className="form-group col-12 mb-3">
                <label htmlFor="catName">Title</label>
                <input
                  type="text"
                  value={editedMediaData.title}
                  onChange={handleTitleChange}
                  className="form-control custom-input my-3"
                  id="catName"
                />
              </div>

              <div className="form-group col-12 mb-3">
                <label htmlFor="catName">Short Description</label>
                <input
                  type="text"
                  value={editedMediaData.shortdescription}
                  onChange={handleDescriptionChange}
                  className="form-control custom-input my-3"
                  id="catName"
                />
              </div>

              <div className="form-group col-12 mb-3">
                <label>Date & Time</label>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateTimePicker
                    value={value}
                    onChange={handleChange}
                    disablePast
                    slotProps={{
                      textField: {
                        variant: "outlined",
                        fullWidth: true,
                        error: false,
                        sx: {
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              borderColor: "#ced4da",
                            },
                            "&:hover fieldset": {
                              borderColor: "#ced4da",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#80bdff",
                            },
                          },
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              </div>

              <div className="row">
                  <div
                    className="col-12 d-flex"
                    style={{ height: "40px", width: "120px" }}
                  >
                    <button
                      type="submit"
                      onClick={handleDiscardClick}
                      disabled={editLoading}
                      style={{ height: "100%", width: "100%" }}
                      className="btn btn-danger save-btn text-uppercase"
                    >
                      Discard
                    </button>{" "}
                    &nbsp;
                    {editLoading ? (
                      <div
                        className="btn btn-primary loader-active save-btn"
                        style={{ height: "100%", width: "100%" }}
                      >
                        <RiLoaderFill
                          size={20}
                          className="spin-animation"
                          color="white"
                        />
                      </div>
                    ) : (
                      <button
                        type="submit"
                        onClick={handleSubmitClick}
                        disabled={editLoading}
                        className="btn btn-primary save-btn text-uppercase"
                        style={{ height: "100%", width: "100%" }}
                      >
                        Save
                      </button>
                    )}
                  </div>
                </div>
            </div>
          </div>
        )}
        <hr />
      </div>
    </div>
  );
}

export default Editnotification;
